'use client'

import { usePageView } from '@/hooks/useAnalytics'
import { Fragment, FunctionComponent } from 'react'

export const GoogleAnalyticsClient: FunctionComponent = () => {
  usePageView()
  return <Fragment />
}